
export default {
    loadData : async function() {
        let listData = require('../assets/visual_effects/data/visualEffectDatas.json');
        return listData;
    }
}